import "./ConfirmModal.scss";

type Props = {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ConfirmModal = ({
  open,
  title,
  message,
  confirmLabel = "删除",
  cancelLabel = "取消",
  danger = true,
  busy = false,
  onConfirm,
  onCancel,
}: Props) => {
  if (!open) {
    return null;
  }

  return (
    <div className="pixso-modal" role="dialog" aria-modal="true">
      <button
        type="button"
        className="pixso-modal__backdrop"
        aria-label="关闭"
        onClick={onCancel}
      />
      <div className="pixso-modal__panel">
        <h3 className="pixso-modal__title">{title}</h3>
        <p className="pixso-modal__message">{message}</p>
        <div className="pixso-modal__actions">
          <button
            type="button"
            className="pixso-modal__btn"
            onClick={onCancel}
            disabled={busy}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`pixso-modal__btn ${
              danger ? "pixso-modal__btn--danger" : "pixso-modal__btn--primary"
            }`}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? "处理中…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
